import React from 'react';
import { FaTimes, FaPlus, FaMinus, FaTrash, FaShoppingBag } from 'react-icons/fa';
import { GiKnifeFork } from 'react-icons/gi';
import { useCart } from '../context/CartContext';
import './CartDrawer.css';

const CartDrawer = ({ onCheckout }) => {
  const {
    items,
    isOpen,
    closeCart,
    removeItem,
    increment,
    decrement,
    itemCount,
    total
  } = useCart();

  return (
    <>
      {/* Backdrop */}
      <div
        className={`cart-backdrop ${isOpen ? 'visible' : ''}`}
        onClick={closeCart}
      />

      {/* Drawer */}
      <div className={`cart-drawer ${isOpen ? 'open' : ''}`} id="cart-drawer">

        {/* Header */}
        <div className="cart-header">
          <div className="cart-header-left">
            <FaShoppingBag className="cart-bag-icon" />
            <span className="cart-title">Your Order</span>
            {itemCount > 0 && (
              <span className="cart-count-badge">{itemCount}</span>
            )}
          </div>

          <button
            className="cart-close-btn"
            onClick={closeCart}
            aria-label="Close cart"
            id="cart-close-btn"
          >
            <FaTimes />
          </button>
        </div>

        {/* Body */}
        <div className="cart-body">
          {items.length === 0 ? (
            <div className="cart-empty">
              <GiKnifeFork className="cart-empty-icon" />
              <p className="cart-empty-title">Your cart is empty</p>
              <p className="cart-empty-sub">
                Browse the menu and add some delicious dishes
              </p>
            </div>
          ) : (
            <div className="cart-items">

              <div className="cart-course-label">
                <GiKnifeFork className="cart-course-icon" />
                <span>Your Items</span>
              </div>

              {items.map((item) => (
                <div className="cart-item" key={item._id}>
                  <div className="cart-item-info">
                    <span className="cart-item-name">{item.name}</span>

                    {/* Item price */}
                    <span className="cart-item-price">
                      €{item.price} × {item.quantity}
                    </span>
                  </div>

                  <div className="cart-item-controls">
                    <button
                      className="qty-btn"
                      onClick={() => decrement(item._id)}
                      aria-label="Decrease quantity"
                      id={`qty-dec-${item._id}`}
                    >
                      <FaMinus />
                    </button>

                    <span className="qty-value">{item.quantity}</span>

                    <button
                      className="qty-btn"
                      onClick={() => increment(item._id)}
                      aria-label="Increase quantity"
                      id={`qty-inc-${item._id}`}
                    >
                      <FaPlus />
                    </button>

                    <button
                      className="remove-btn"
                      onClick={() => removeItem(item._id)}
                      aria-label="Remove item"
                      id={`remove-${item._id}`}
                    >
                      <FaTrash />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        {items.length > 0 && (
          <div className="cart-footer">
            <div className="cart-total-row">
              <span>Total</span>
              <span className="cart-total-amount">
                €{total.toFixed(2)}
              </span>
            </div>

            <button
              className="btn-primary cart-checkout-btn"
              onClick={() => {
                closeCart();
                onCheckout();
              }}
              id="cart-checkout-btn"
            >
              <FaShoppingBag />
              <span>Proceed to Checkout</span>
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default CartDrawer;